module.exports = __webpack_public_path__ + "static/media/Fitness-Hr.40d879e8.png";